import { render, staticRenderFns } from "./BooksUsage.vue?vue&type=template&id=74dacba1&"
import script from "./BooksUsage.vue?vue&type=script&lang=js&"
export * from "./BooksUsage.vue?vue&type=script&lang=js&"
import style0 from "./BooksUsage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74dacba1')) {
      api.createRecord('74dacba1', component.options)
    } else {
      api.reload('74dacba1', component.options)
    }
    module.hot.accept("./BooksUsage.vue?vue&type=template&id=74dacba1&", function () {
      api.rerender('74dacba1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/BooksUsage.vue"
export default component.exports